import { CURATORSHIP_TIERS } from '@cannect/new-components/atoms/CuratorshipGauge/tiers'

/**
 * Opções do filtro "Aderência à Curadoria" do marketplace.
 *
 * `id` é o valor enviado na querystring como `curatorship_range` e precisa bater
 * com as chaves de `CURATORSHIP_RANGES` no productService da API — é lá que a
 * faixa vira cláusula SQL.
 *
 * A faixa "Readequação" (0-20%) não é ofertada como filtro, espelhando o
 * comportamento anterior, em que não existia opção "0 estrelas".
 */
export const CURATORSHIP_RANGE_OPTIONS = CURATORSHIP_TIERS.filter((tier) => tier.min >= 20)
  .slice()
  .reverse()
  .map((tier) => ({
    id: tier.key,
    name: `${tier.min} a ${tier.max}%`,
    className: tier.className
  }))
